import { initializeMasks } from "./input-masks";

/**
 * Formats a digit string as (XXX) XXX-XXXX, inserting parens, space, and hyphen.
 * @param {string} digits - string of digits only
 * @returns {string}
 */
export function phoneFormatter(digits) {
  const trimmed = digits.slice(0, 10);

  if (trimmed.length === 0) {
    return "";
  }

  if (trimmed.length <= 3) {
    return `(${trimmed}`;
  }

  if (trimmed.length <= 6) {
    return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3)}`;
  }

  return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
}

export function initializePhoneMasks(container) {
  return initializeMasks(container, "input.phone-mask, input[type='tel']", phoneFormatter, 10);
}
